import { tenantSlugFromHostname } from "@/lib/tenant";
import type { TenantSlug } from "@/lib/theme-presets";

export interface GoogleClassroomImportConfig {
  available: boolean;
  enabled: boolean;
  oauthClientId: string;
}

type ClassroomImportEnvironment = Partial<Record<
  | "VITE_GOOGLE_CLASSROOM_MUFID_IMPORT_ENABLED"
  | "VITE_GOOGLE_CLASSROOM_MUFID_OAUTH_CLIENT_ID",
  string
>>;

const HIDDEN: GoogleClassroomImportConfig = Object.freeze({
  available: false,
  enabled: false,
  oauthClientId: "",
});

const DISABLED: GoogleClassroomImportConfig = Object.freeze({
  available: true,
  enabled: false,
  oauthClientId: "",
});

const CLASSROOM_IMPORT_ENVIRONMENT: Partial<Record<TenantSlug, {
  enabled: keyof ClassroomImportEnvironment;
  oauthClientId: keyof ClassroomImportEnvironment;
}>> = {
  mufid: {
    enabled: "VITE_GOOGLE_CLASSROOM_MUFID_IMPORT_ENABLED",
    oauthClientId: "VITE_GOOGLE_CLASSROOM_MUFID_OAUTH_CLIENT_ID",
  },
};

export function googleClassroomImportConfigForHostname(
  hostname: string = window.location.hostname,
  env: ClassroomImportEnvironment = import.meta.env,
): GoogleClassroomImportConfig {
  const tenant = tenantSlugFromHostname(hostname);
  const fields = tenant === null ? null : CLASSROOM_IMPORT_ENVIRONMENT[tenant];
  if (!fields) {
    return HIDDEN;
  }
  if (env[fields.enabled]?.trim().toLowerCase() !== "true") {
    return DISABLED;
  }

  const oauthClientId = env[fields.oauthClientId]?.trim() ?? "";
  if (!/^\d+-[a-z0-9-]+\.apps\.googleusercontent\.com$/.test(oauthClientId)) {
    return DISABLED;
  }
  return { available: true, enabled: true, oauthClientId };
}
